import { Button, Label, Spacing } from '@approvalmax/ui/src/components';
import { memo, useCallback } from 'react';
import { useHover } from 'react-use';

import { messages } from './ListItem.messages';
import { Root } from './ListItem.styles';
import { ListItemProps } from './ListItem.types';

export const ListItem = memo<ListItemProps>((props) => {
    const { email, onDeleteEmail } = props;

    const onDeleteButtonClick = useCallback(() => {
        onDeleteEmail(email);
    }, [onDeleteEmail, email]);

    const [hoverable] = useHover((hover) => (
        <Root>
            <Label spacing='4'>{email}</Label>

            <Spacing height={28} />

            {hover && (
                <Button size='xsmall' color='red40' onClick={onDeleteButtonClick}>
                    {messages.deleteButtonText}
                </Button>
            )}
        </Root>
    ));

    return hoverable;
});
